import { DataService } from "../../../../Autofacets-Core/src/app/services/data.service";
import { GenericResponse } from "../business-entities/generic-response";
import { Urls } from "../../../../Autofacets-Core/src/app/utils/urls";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})

export class WarningLightDataService {
    constructor(private dataProvider: DataService) {
    }

    async getWarningLightList(requestModel: any): Promise<GenericResponse<any>> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.GetWarningLightList, requestModel).toPromise();
    }

    AddUpdateWarningLight(addEditWarningLightModel: any): Promise<GenericResponse<any>> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.AddUpdateWarningLight, addEditWarningLightModel).toPromise();
    }

    getWarningLightById(Id: number): Promise<any> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetWarningLightById, Id).toPromise();
    }

    deleteWarningLight(Id: number): Promise<GenericResponse<boolean>> {
        return this.dataProvider.Delete<GenericResponse<boolean>>(Urls.DeleteWarningLight, Id).toPromise();
    }

    async getWarningLightDropDown(language: string): Promise<GenericResponse<any>> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetWarningLightDropdown,language).toPromise();
    }

}